import React from 'react'
import dayjs from 'dayjs'
import { Coupon } from 'types/coupon'
import { useTranslation } from 'react-i18next'
import { LabelTiny } from 'components/base-ui/FontsV2'
import CouponItem from 'components/base-ui/CouponItem'
import CouponOwner from 'components/base-ui/CouponOwner'

interface DineInCouponItemProps {
  coupon: Coupon
  isShowClickIcon: boolean
  onClickCondition: (serialNumber: string) => void
}

const DineInCouponItem = ({ coupon, onClickCondition, isShowClickIcon }: DineInCouponItemProps) => {
  const { t } = useTranslation()
  const expireDate = dayjs(coupon.endTime).format('DD/MM/YY')

  return (
    <CouponItem
      coupon={coupon}
      onClickCondition={onClickCondition}
      detail={
        <>
          <LabelTiny color="darkGrey">{t('dineIn.coupon.expiredDate', { date: expireDate })}</LabelTiny>
          {coupon.lineUser && <CouponOwner {...coupon.lineUser} />}
        </>
      }
      isShowClickIcon={isShowClickIcon}
    />
  )
}

export default DineInCouponItem
